import { DropdownOptionModel } from './dropdown-option-model';


export const PAYMENT_FREQUENCY: DropdownOptionModel<string>[] = [
  { value: 'Monthly', display: 'Monthly' },
  { value: 'Annual', display: 'Annual' }
];
